/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscreated2Inputs */

const en_downloadlinkscreated2 = /** @type {(inputs: Downloadlinkscreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link created`)
};

const de_downloadlinkscreated2 = /** @type {(inputs: Downloadlinkscreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link erstellt`)
};

/**
* | output |
* | --- |
* | "Link created" |
*
* @param {Downloadlinkscreated2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscreated2 = /** @type {((inputs?: Downloadlinkscreated2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscreated2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscreated2(inputs)
	return de_downloadlinkscreated2(inputs)
});
export { downloadlinkscreated2 as "downloadLinksCreated" }